import {PinProtect} from '~/features/Auth/PinProtect';

import {ManageConfig} from '~/features/Config';

export const ManageConfigScene = () => {
  return (
    <div className="bg-background min-h-screen">
      <PinProtect>
        <ManageConfig />
      </PinProtect>
    </div>
  );
};
